import React from 'react';

import { motion } from 'framer-motion';
export default function CargoDetailSkeleton() {
  return (
    <div className="w-full flex flex-col gap-10 min-h-screen py-10 lg:px-5 px-5" dir="rtl">
    <motion.div
    initial="hidden"
    animate="visible"
    variants={{}}
    className="max-w-6xl mx-auto w-full mt-20">
    
      <p className="text-sm text-gray-500 mb-4">
        <span className="inline-block w-40 h-4 bg-gray-300 rounded animate-pulse" />
      </p>
    
    <div className="bg-white rounded-2xl w-full p-6 lg:p-2">
    <div className="flex flex-col lg:flex-row lg:justify-between gap-8">
    
    {/* left column: title + description */}
    <div className="w-full lg:w-[55%] min-w-0">
    
    <div className="flex items-start gap-3 mb-4">
          <div className="text-sm bg-[#0075FF0D] text-blue-950 rounded-lg px-3 py-1">
              <div className="w-20 h-4 bg-gray-300 rounded animate-pulse" />
          </div>
    </div>
    
    
    {/* details card (kept where your original placed it) */}
    <motion.aside
    variants={{}}
    className=" flex-shrink-0">
    <div className="bg-white bg-opacity-50 rounded-lg p-5 ">
      <div className="flex justify-start items-center w-full">
          <h2 className="text-lg text-special font-medium mb-4">
              <span className="inline-block w-28 h-5 rounded animate-pulse" >
                توضیحات
              </span>

          </h2>
      </div>
    
    
        <div className="flex flex-col divide-y-[1px] divide-gray-300 gap-2 mb-4 w-full">
            
            {Array.from({ length: 7 }).map((_, i) => (
            <div key={i} className="flex flex-row justify-between py-2 items-center w-full">
              <div className="h-3 w-28 bg-gray-300 rounded animate-pulse" />
              <div className="h-4 w-32 bg-gray-300 rounded animate-pulse" />
            </div>
            ))}
        
        </div>
    
        <p className="text-lg text-special font-medium my-6">
            <span className="inline-block w-40 h-5 bg-gray-300 rounded animate-pulse" />
        </p>
    
        <div className={`transition-all duration-200 max-h-30 overflow-hidden text-gray-600 break-words whitespace-pre-line`}>
            <div className="space-y-2">
            <div className="h-3 bg-gray-300 rounded w-full animate-pulse" />
            <div className="h-3 bg-gray-300 rounded w-3/4 animate-pulse" />
            </div>
        </div>
        
    </div>
    
    </motion.aside>
    
    
    </div>
    {/* optional extra content on mobile could go here */}
    <div className="flex flex-col lg:justify-center justify-center items-end mt-10 gap-3 lg:w-[35%] w-full ">
        <p className="text-[20px] w-full text-center mb-5">
        <span className="inline-block w-40 h-6 bg-gray-300 rounded animate-pulse" />
        </p>
          <a className="w-full inline-flex justify-center items-center gap-2 bg-special bg-opacity-30 text-white py-2 rounded-md text-sm">
            <div className="h-4 w-4 bg-gray-200 rounded" />
            <div className="h-5 w-20 bg-gray-200 rounded animate-pulse" />
        </a>
        
        <button className="w-full inline-flex justify-center items-center gap-2 bg-white text-red-600 border border-red-600 py-2 rounded-md text-sm">
        <div className="h-4 w-28 bg-gray-300 rounded animate-pulse" />
        </button>
    </div>
    
    </div>
    
    </div>
    
    </motion.div>
    </div>
  );
}
